import { render, staticRenderFns } from "./tagbox.vue?vue&type=template&id=b9e1b79a&"
import script from "./tagbox.vue?vue&type=script&lang=ts&"
export * from "./tagbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9e1b79a')) {
      api.createRecord('b9e1b79a', component.options)
    } else {
      api.reload('b9e1b79a', component.options)
    }
    module.hot.accept("./tagbox.vue?vue&type=template&id=b9e1b79a&", function () {
      api.rerender('b9e1b79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/tagbox.vue"
export default component.exports